import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";

const paymentService = axios.create({
	baseURL: `${constants.paymentServiceUrl}/`,
});

paymentService.interceptors.request.use((config) => {
	let userInfo = store.getState().userInfo;
	config.headers[constants.authTokenBackendKey] = userInfo.authToken;
	config.headers["sessionID"] = userInfo.sessionId;
	config.headers["redirectToAuth"] = true;
	return config;
});

paymentService.interceptors.response.use(function (response) {
	return response;
}, errorHandler);

export default paymentService;
